/**
* @ngdoc directive
* @name Dropdown Actions Keydown
*
* @description
  Selects next / previous action on down / up click on buttons dropdown
*
* @scope
* @param {Function} getOptions - get available actions
* @param {Object} action - selected action
*
* @example
  <div class='clearfix btn-group-dropdown' ng-init='action = { selected: { name: "Do Something" } }' style='display: inline-block'>
  <button-spinner
    name="{{ action.selected.name }}"
    ng-click="alert()"
    class="btn-primary"
  >
  </button-spinner>
  <button
    class='btn btn-primary btn-group-dropdown__select'
    type="button"
    templateUrl='#{CONFIG.PATH.common}templates/btn-group.dropdown.html'
    ng-model="action.selected"
    bs-options="item.name for item in [{ name: 'Do Something' }, { name: 'Do Something Else' }]"

    dropdown-actions-keydown
    get-options='[{ name: "Do Something" }, { name: "Do Something Else" }]'
    action='action'

    bs-select>
  </button>
  </div>
*/

(function() {
  'use strict';

  app.directive('dropdownActionsKeydown', directive);

  function directive () {
    return {
      link: link,
      restrict: 'A',
      scope: {
        getOptions: '&',
        action: '='
      }
    };

    function link($scope, $element) {
      $element.on('keydown', function (event) {
        var isUpPressed = event.keyCode === 38;
        var isDownPressed = event.keyCode === 40;

        if (!isUpPressed && !isDownPressed) {
          return;
        }

        var allButtons = $('.dropdown-menu__btn');
        var allOptions = $scope.getOptions();
        var currentActionIndex = _.findIndex(allOptions, function (action) {
          return action.name === $scope.action.selected.name;
        });
        var nextActionIndex = currentActionIndex;
        if (isUpPressed) {
          nextActionIndex--;
          if (nextActionIndex === -1) {
            nextActionIndex = allButtons.length - 1;
          }
        } else if (isDownPressed) {
          nextActionIndex++;
          if (nextActionIndex === allButtons.length) {
            nextActionIndex = 0;
          }
        }
        delete($scope.action.selected.choosed);
        $scope.action.selected = allOptions[nextActionIndex];
        $scope.action.selected.choosed = true;
      });
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/dropdownActionsKeydown.js